import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { StyleClassModule } from 'primeng/styleclass';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { RouterModule, Router, NavigationStart } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  COMPANY_INFO,
  STAFF_STATE,
  STATSIG_STATE,
  TENANTS_INFO,
} from 'apps/ff-frontend/src/app/state/app.state';
import {
  LangChangeEvent,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import {  ShortNamePipe} from '@fitness-force/pipes/short-name'
import { BehaviorSubject, Observable } from 'rxjs';
import { TooltipModule } from 'primeng/tooltip';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import Statsig from 'statsig-js';
import { RouteStateService, SidebarService } from '@fitness-force/shared';
import { BadgeModule } from 'primeng/badge';
import { StaffPreferencesComponent } from '../staff-preferences/staff-preferences.component';
import { AuthSevices } from '@fitness-force/api';
import { TenantService } from '@fitness-force/api';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    CommonModule,
    StyleClassModule,
    SelectModule,
    InputTextModule,
    ScrollPanelModule,
    ButtonModule,
    RouterModule,
    TooltipModule,
    AvatarModule,
    AvatarGroupModule,
    ShortNamePipe,
    BadgeModule,
    StaffPreferencesComponent,
    TranslateModule
  ]
})
export class SidebarComponent implements OnInit, AfterViewInit {
  @ViewChild('sidebar', { static: true }) sidebar: ElementRef;
  companyDetails: any;
  companyLogo!: Observable<any> | any;
  tenantLogo!: Observable<any> | any;
  selectedUrl: string;
  userDetails$ = new BehaviorSubject<any>([]);
  currentUserDetails: any;
  public companyInfoDetail$!: Observable<any>;
  public tenantInfoDetail$!: Observable<any>;

  sidebarMinimized: boolean = false;
  hoveMenu = false;
  activeIndex: number | null;
  Menus = new BehaviorSubject<Array<any>>([]);
  AdminMenu = {
    title: 'ADMIN',
    url: '/admin',
    activeUrl: 'admin',
    icon: 'fa-cog',
    icon2: '',
    submenus: [],
  };
  sidebarMinizeClass: string = 'lg:sticky';
  hideSidebar: boolean = false;
  langDirection=new BehaviorSubject<string>('ltr');
  showAvailablity = new BehaviorSubject<boolean>(false);
  showNotificationIcon = new BehaviorSubject<boolean>(false);
  showEnterpriseMaster = new BehaviorSubject<boolean>(false);
  showSidebar: boolean=false;
  selectedStaffId:number=0;
  isPresaleTenant:boolean=false;
  constructor(
    private store: Store,
    private router: Router,
    private translate: TranslateService,
    private authService: AuthSevices,
    private cd: ChangeDetectorRef,
    private routeStateService: RouteStateService,
    private sidebarService : SidebarService,
    private tenantService: TenantService
  ) {
    this.isPresaleTenant=this.tenantService.IsPresaleTenant();
    this.Menus.next(this.getInitialMenus());
    this.sidebarService.setMenus(this.Menus.value);

    this.router.events.subscribe({
      next: (event: any) => {
        if (event instanceof NavigationStart) {
          this.selectedUrl = event.url.split('?')[0];
        }
      },
    });
    this.CheckAndSetSelectedUrl();
  }

  async ngOnInit(): Promise<void> {
    this.companyInfoDetail$ = this.store.select(COMPANY_INFO);
    this.tenantInfoDetail$ = this.store.select(TENANTS_INFO);
    this.companyInfoDetail$.subscribe((responseData) => {
      if (responseData?.selectedLang?.LANG_CODE) {
        this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
        this.translate.use(responseData?.selectedLang?.LANG_CODE);
      }
      if (responseData.compDetails != null) {
        this.companyDetails = responseData.compDetails;
        this.companyLogo = this.companyDetails.logo;
      }
    });

    this.tenantInfoDetail$.subscribe((responseData) => {
      if (responseData.selected_tenant) {
        this.tenantLogo = responseData.selected_tenant.image;
      }
      this.currentUserDetails = this.authService.currentUserDetails();
      if (this.currentUserDetails) {
        this.store.select(STAFF_STATE).subscribe(async (data: any) => {
          if (data && data.staffList && data.staffList.length > 0) {
            const user = data.staffList.find((o: any) => { return o.id === parseInt(this.currentUserDetails.Id) });
            if (user) {
              this.userDetails$.next(user);
              this.selectedStaffId = user.id;
            }           
          }
        });
      }
    });

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      const dir = CONSTANTS_DATA.ALL_LANGUAGES.find((lang)=>(lang.LANG_CODE===event.lang))?.dir;
      if(dir)
      this.langDirection.next(dir);
     });

     this.tenantService.isPresaleTenant$.subscribe(isPresaleTenant => {
      this.isPresaleTenant = isPresaleTenant;
      this.sidebarService.setMenus(this.getInitialMenus())
      this.updateMenusBasedOnFeatureFlags();
      this.Menus.next(this.sidebarService.getMenus());
      this.cd.detectChanges();
    });
    this.cd.detectChanges();
  }

  async ngAfterViewInit() { 
    await this.timeout(1000);
    // feature-flag
    this.store.select(STATSIG_STATE).subscribe({next:(statsigUser:any)=>{
      if(statsigUser && statsigUser.user != null)
      {
        this.updateMenusBasedOnFeatureFlags();
        this.sidebarService.updateMenusBasedOnStatsigState(statsigUser);
        this.Menus.next(this.sidebarService.getMenus());
        this.cd.detectChanges();
      }
    }
   });

    //this.updateMenusBasedOnFeatureFlags();
    if(Statsig.checkGate("show_create_or_manage_staff_availability"))
    {
      this.showAvailablity.next(true);
    }
    else{
      this.showAvailablity.next(false);
    }

    if(Statsig.checkGate("show_enterprise"))
    {
      this.showEnterpriseMaster.next(true);
    }
    else{
      this.showEnterpriseMaster.next(false);
    }
    this.cd.detectChanges();
  }

  updateMenusBasedOnFeatureFlags() {
    let menus = this.sidebarService.getMenus();
    this.sidebarService.updateMenuWithFlag(menus,"client-management", 'show_upgrade', {
      title: 'Upgrade',
      name: 'upgrade',
      url: '/client-management/upgrade',
      activeUrl: '/client-management/upgrade',
      icon: '',
      disabled: this.isPresaleTenant,
    });

    this.sidebarService.updateMenuWithFlag(menus,"client-management", 'show_transfer',  {
      title: 'Transfer',
      name: 'transfer',
      url: '/client-management/client-transfer',
      activeUrl: '/client-management/client-transfer',
      icon: '',
      disabled: this.isPresaleTenant,
    });

    this.sidebarService.updateMenuWithFlag(menus,"pos", 'show_payengine_dispute_management', 
    {
      title: 'DISPUTEMANAGEMENT',
      name: 'dispute-management',
      url: '/client-management/dispute-management',
      activeUrl: '/client-management/dispute-management',
      icon: 'fa-user-minus',
      disabled: false,
    });

    this.sidebarService.updateMenuWithFlag(menus,"pos", 'show_payengine_settlements', 
    {
      title: 'SETTLEMENTS',
      name: 'settlements',
      url: '/client-management/settlements',
      activeUrl: '/client-management/settlements',
      icon: 'fa-user-minus',
      disabled: false,
    });

    this.sidebarService.updateMenuWithFlag(menus,"pos", 'show_payengine_transactions', 
    {
      title: 'TRANSACTIONS',
      name: 'transactions',
      url: '/client-management/transactions',
      activeUrl: '/client-management/transactions',
      icon: 'fa-user-minus',
      disabled: false,
    });
    // this.sidebarService.updateMenuWithFlag(menus,"pos", 'show_campaign', 
    // {
    //   title: 'TRANSACTIONS',
    //   url: '/client-management/transactions',
    //   activeUrl: '/client-management/transactions',
    //   icon: 'fa-user-minus',
    //   disabled: false,
    // });
    this.sidebarService.updateMenuWithFlag(menus,"pos", 'show_adhoc_charges', 
    {
        title: 'ADHOC',
        name: 'adhoc-charges',
        url: '/pos/adhoc-charges',
        activeUrl: '/pos/adhoc-charges',
        icon: 'fa-chart-line',
        disabled: false,
    });
    this.sidebarService.updateMenuWithFlag(menus,"crm", 'show_staff_2way_message_notifciation', 
    {
        title: 'INBOX',
        name: 'inbox',
        url: '/crm/inbox',
        activeUrl: '/crm/inbox',
        icon: '',
        disabled: false,
    });
    this.Menus.next(this.sidebarService.getMenus());
    this.cd.detectChanges();
  }

  CheckAndSetSelectedUrl(): void {
    let url = this.router.url;
    this.selectedMenu(url?.split('?')[0]);
  }

  toggleSideBarMinimized() {
    if (this.hoveMenu) this.hoveMenu = false;
    this.sidebarMinimized = !this.sidebarMinimized;
  }

  selectedMenu(url: string) {
    this.selectedUrl = url;
  }

  removeActiveIndex() {
    this.activeIndex == null;
  }

  client2LetterName(name: string): string {
    if (name) {
      const nameArray = name.split(" ");
      const newNameArray = [];
      for (let i = 0; i < nameArray.length; i++) {
        if (newNameArray.length >= 2)
          break;

        if (nameArray[i]) {
          newNameArray.push(nameArray[i]);
        }
      }
      return newNameArray.join(" ");
    }
    else {
      return "";
    }
  }

  getMenus()
  {
    return this.Menus.getValue()
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  NavigateToStaffAvailability(staffId: number)
  {
    this.routeStateService.saveCurrentRoute();
    this.router.navigate(['/admin/staff-availability',staffId]);
  }

  handleCloseSidebar(event:any)
  {
    this.showSidebar=false;
  }

  isUserCreatedWithinLast7Days(createdDate: string): boolean {
    const userCreatedDate = new Date(createdDate);
    const currentDate = new Date();
    const timeDifference = currentDate.getTime() - userCreatedDate.getTime();
    const daysDifference = timeDifference / (1000 * 3600 * 24);
    return daysDifference <= 7;
  }

  getInitialMenus():any[] {
    return [
      {
        title: 'CRM',
        name: 'crm',
        url: '',
        activeUrl: 'crm',
        icon: 'fa-chart-pie',
        icon2: '',
        disabled: false,
        submenus: [
          {
            title: 'PIPELINE',
            name: 'sales-pipeline',
            url: '/crm/sales-pipeline',
            activeUrl: '/crm/sales-pipeline',
            icon: '',
            disabled: false,
          },
          {
            title: 'TASKS',
            name: 'tasks',
            url: '/crm/task-list',
            activeUrl: '/crm/task-list',
            icon: '',
            disabled: false,
          },
          {
            title: 'PROSPECTS',
            name: 'prospects',
            url: '/crm/prospect-list',
            activeUrl: '/crm/prospect-list',
            icon: '',
            disabled: false,
          },
          {
            title: 'SALES_CALENDER',
            name: 'sales-calendar',
            url: '/crm/sales-calendar',
            activeUrl: '/crm/sales-calendar',
            icon: '',
            disabled: false,
          },
          {
            title: 'TRIALS',
            name: 'trials',
            url: '/crm/trial-list',
            activeUrl: '/crm/trial-list',
            icon: '',
            disabled: false,
          },
          {
            title: 'CONTACTS',
            name: 'contacts',
            url: '/crm/contacts-list',
            activeUrl: '/crm/contacts-list',
            icon: '',
          }
        ],
      },
      {
        title: 'CLIENT_MANAGEMENT',
        name: 'client-management',
        url: '',
        activeUrl: 'client-management',
        icon: 'fa-users',
        icon2: '',
        disabled: false,
        submenus: [
          {
            title: 'ACTIVE_CLIENTS',
            name: 'active-clients',
            url: '/client-management/active-clients',
            activeUrl: '/client-management/active-clients',
            icon: 'fa-user-plus',
            disabled: false,
          },
          {
            title: 'EX_CLIENTS',
            name: 'ex-clients',
            url: '/client-management/ex-clients',
            activeUrl: '/client-management/ex-clients',
            icon: 'fa-user-minus',
            disabled: false,
          },
          {
            title: 'IRREGULAR_CLIENTS',
            name: 'irregular-clients',
            url: '/client-management/irregular-clients',
            activeUrl: '/client-management/irregular-clients',
            icon: 'fa-user-minus',
            disabled: false,
          },
          {
            title: 'CHECK_IN',
            name: 'check-in',
            url: '/client-management/check-in',
            activeUrl: 'client-management/check-in',
            icon: 'fa-user-minus',
            disabled: false,
          },
          {
            title: 'Freeze',
            name: 'freeze',
            url: '/pos/freeze',
            activeUrl: '/pos/freeze',
            icon: '',
            disabled:  this.isPresaleTenant,
          }
        ],
      },
      {
        title: 'SCHEDULE',
        name: 'schedule',
        url: '',
        activeUrl: '/schedule',
        icon: 'fa-calendar-plus',
        icon2: '',
        disabled: false,
        submenus: [
          {
            title: 'FITNESS_CALENDAR',
            name: 'fitness-calendar',
            url: '/schedule',
            activeUrl: '/schedule/fitness-calendar',
            icon: 'fa-calendar-plus',
            disabled: false,
          },
          {
            title: 'SCHEDULE_CLASS',
            name: 'schedule-class',
            url: '/schedule/schedule-class',
            activeUrl: '/schedule/schedule-class',
            icon: 'fa-calendar-plus',
            disabled: false,
          },
          {
            title: 'CLASS_LIST',
            name: 'class-list',
            url: '/schedule/class-list',
            activeUrl: '/schedule/class-list',
            icon: 'fa-calendar-plus',
            disabled: false,
          }
        ],
      },
      {
        title: 'POS',
        name: 'pos',
        url: '',
        activeUrl: 'pos',
        icon: 'fa-chart-line',
        icon2: '',
        disabled: false,
        submenus: [
          {
            title: 'POS',
            name: 'pos-addon-charges',
            url: '/pos/pos-addon-charges',
            activeUrl: '/pos/pos-addon-charges',
            icon: 'fa-chart-line',
            disabled: false,
          }
        ],
      },
      {
        title: 'REPORT',
        name: 'report',
        url: '/report',
        activeUrl: 'report',
        icon: 'fa-chart-bar',
        icon2: '',
        disabled: false,
        submenus: [],
      }
    ];
  }

  openFeedback()
  {
    window.postMessage({
      target: 'FeaturebaseWidget',
      data: { action: 'openFeedbackWidget' },
  })
  }

  
}
